var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikedVideosOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M18.77 11h-4.23l1.519-4.941C16.379 5.03 15.539 4 14.379 4c-.578 0-1.14.238-1.52.648L7 11H3v10h14.43c1.058 0 1.98-.672 2.191-1.61l1.34-6c.27-1.242-.781-2.39-2.191-2.39zM7 20H4v-8h3zm12.98-6.828-1.34 6c-.1.476-.609.828-1.21.828H8v-8.61l5.602-6.062c.187-.207.476-.328.777-.328.262 0 .5.11.633.3a.545.545 0 0 1 .09.47l-1.524 4.94L13.18 12h5.582c.41 0 .797.172 1.027.46a.794.794 0 0 1 .191.712zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikedVideosOutline);
export default __webpack_public_path__ + "static/media/liked_videos_outline.a84f531cff40b02e586283f57fab1c6c.svg";
export { ForwardRef as ReactComponent };